import { render } from "./ProjectAttachedListComponent.vue?vue&type=template&id=7c7e5118"
import script from "./ProjectAttachedListComponent.vue?vue&type=script&lang=js"
export * from "./ProjectAttachedListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__